import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import theme, { textBold } from 'theme/theme';
import Card from 'base/components/Card/index';
import MainTitle from 'base/components/MainTitle/index';
import Flex from 'base/components/Flex/Flex';
import ButtonGroup from 'base/components/ButtonGroup';
import LargeIconButton from 'base/components/LargeIconButton';
import { CloseIcon } from 'base/components/Icon/index';

const ItemContainer = styled(Flex)`
  margin: -10px;
  @media (min-width: ${theme.breakpoints.desktopLarge}) {
    margin: -20px;
  }
`;

const ItemWrapper = styled(Card)`
  flex: 0 calc(100% - 20px);
  margin: 10px;
  color: ${theme.colors.primary};
  &:hover {
    cursor: pointer;
  }
  padding: 10px 20px;
  ${textBold};
  
  @media (min-width: ${theme.breakpoints.tablet}) {
    flex: 0 calc(50% - 20px);
  }
  @media (min-width: ${theme.breakpoints.desktopLarge}) {
    flex: 0 calc(25% - 40px);
    margin: 20px;
  }
  
`;
const ToolboxItem = ({ item, onTakeItem, widgets }) => { // eslint-disable-line
  const widg = widgets.find((w) => w.id === item.i);
  return (
    <ItemWrapper
      onClick={onTakeItem.bind(undefined, item)} // eslint-disable-line
    >
      {widg.title}
    </ItemWrapper>
  );
};
ToolboxItem.propTypes = {
  item: PropTypes.objectOf(PropTypes.any),
  onTakeItem: PropTypes.func,
};
ToolboxItem.defaultProps = {
  item: {},
  onTakeItem: () => {},
};

const ToolboxWrapper = styled.div`
  padding: 25px 25px;
  background: ${theme.colors.medium};
  color: ${theme.colors.dark};
  
  @media (min-width: ${theme.breakpoints.desktop}) {
    padding: 45px 65px;
  }
  
  ${(props) => props.isAdminMode && css`
    background: ${theme.colors.darker};
  `}
`;

const Toolbox = ({ items, onTakeItem, onClose, widgets, isAdminMode }) => { // eslint-disable-line
  const previews = items.map((item) => (
    <ToolboxItem
      key={item.i}
      item={item}
      onTakeItem={onTakeItem}
      widgets={widgets}
    />
  ));
  return (
    <ToolboxWrapper isAdminMode={isAdminMode} className="toolbox">

      {!isAdminMode && (
        <Flex style={{ marginBottom: '35px' }}>

          <MainTitle>
                  Customise dashboard
          </MainTitle>

          <ButtonGroup background={theme.colors.darker} pullRight>
            <LargeIconButton variant="" onClick={onClose}>
                  Save & close
              {' '}
              <CloseIcon size="30px" />
            </LargeIconButton>
          </ButtonGroup>
        </Flex>
      )}

      <ItemContainer flexWrap="wrap">
        {items.length > 0 ? previews : 'All available widgets in use'}
      </ItemContainer>

    </ToolboxWrapper>
  );
};
Toolbox.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any),
  onTakeItem: PropTypes.func,
  onClose: PropTypes.func,
  isAdminMode: PropTypes.bool,
};
Toolbox.defaultProps = {
  items: [],
  onTakeItem: () => {},
  onClose: () => {},
  isAdminMode: false,
};

export default Toolbox;
